import style from "./Button.module.css"
import { Loader } from "../Loader/Loader"

function Button({ label = 'label-button', onClick, disabled, red, white, loading }) {
    let classN = style.button
    red && (classN = `${classN} ${style.red}`)
    white && (classN = `${classN} ${style.white}`)
    loading && (classN = `${classN} ${style.loading}`)

    return <>
        <button
            className={classN}
            onClick={() => onClick && !loading ? onClick() : null}
            disabled={disabled}
        >
            {
                <>
                    <div>{loading && <Loader />}</div>
                    <div className={loading ? style.none : null}>{label}</div>
                </>
            }
        </button>
    </>

}

export { Button }